import React from "react";
import { Input } from "atomize";
import { theme } from "../settings/config";

function TimeInput({ handleChange, value, ...others }) {
    return (
        <Input
            bg="surface"
            m={{ b: "0.5rem" }}
            value={value}
            rounded="15px"
            type="time"
            border="3px solid"
            borderColor={theme.colors.surface}
            focusBorderColor={theme.colors.gunmetal}
            textColor={theme.colors.dark}
            p={{ x: "1rem" }}
            h="3.5rem"
			w="100% !important"
			style={{ WebkitAppearance: "none" }}
            onChange={(e) => {
                handleChange(e.target.value);
            }}
            {...others}
        />
    );
}

export default TimeInput;
